const Directive = {
    install (Vue) {
        Vue.directive('longPress', {
            bind (el, { value, modifiers }) {
                let u = navigator.userAgent
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
                let isAndroid = u.match(/(Android)\s+([\d.]+)/)
                if(isiOS||isAndroid) {
                    let timeout = null
                    let x, y, x1, y1
                    el.addEventListener('touchstart', (e) => {
                        if (modifiers.stop) {
                            e.stopPropagation()
                        }
                        if (modifiers.prevent) {
                            e.preventDefault()
                        }
    
                        let len = e.touches.length
                        if (len > 1) {
                            // 多手指操作不触发长按事件
                            clearTimeout(timeout)
                            return
                        }
                        x = e.targetTouches[0].clientX
                        y = e.targetTouches[0].clientY
    
                        timeout = setTimeout(() => {
                            value.methods.call(this, {
                                ...value,
                                $el: el,
                                $event: e
                            })
                        }, 680)
                    }, { passive: false })
    
                    el.addEventListener('touchmove', (e) => {
                        if (modifiers.stop) {
                            e.stopPropagation()
                        }
                        if (modifiers.prevent) {
                            e.preventDefault()
                        }
    
                        x1 = e.targetTouches[0].clientX
                        y1 = e.targetTouches[0].clientY
                        let movedX = Math.abs(x1 - x)
    
                        let movedY = Math.abs(y1 - y)
    
                        if (movedX > 10 || movedY > 10) {
                            clearTimeout(timeout)
                        }
                    }, { passive: false })
    
                    el.addEventListener('touchend', (e) => {
                        if (modifiers.stop) {
                            e.stopPropagation()
                        }
                        if (modifiers.prevent) {
                            e.preventDefault()
                        }
    
                        clearTimeout(timeout)
                    }, { passive: false })
                }
            }
        })
    }
}

export default Directive
